module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "Basic-Text-Frame"
  }, [_c('p', {
    staticClass: "next"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "image/1.png"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "Body_EPI"
  }, [_vm._v("The young man who has not wept is a savage, and the old man who will not laugh "), _c('span', {
    staticClass: "noBreak"
  }, [_vm._v("is a fool.")])]), _vm._v(" "), _c('p', {
    staticClass: "Body_EPIS"
  }, [_vm._v("—George Santayana 1863–1952"), _c('br'), _vm._v("Spanish-American philosopher")]), _vm._v(" "), _c('p', {
    staticClass: "Body_EPI"
  }, [_vm._v("When it comes to shaping our decisions and our actions, feeling counts every bit as much—and often more—tha"), _c('span', {
    staticClass: "noBreak"
  }, [_vm._v("n thought.")])]), _vm._v(" "), _c('p', {
    staticClass: "Body_EPIS _idGenParaOverride-1"
  }, [_vm._v("—Daniel Goleman"), _c('br'), _vm._v("American psychologist")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-773fe5c7","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/NothingsWrong-4.vue
// module id = 72
// module chunks = 0